import React from 'react';
import { useSelector } from 'react-redux';
import { CellInfo } from 'react-table';

import { ViewFrame, ListTable } from '../../components';
import {
  deleteVideoRequest,
  getVideoListRequest,
  setVideoListDirty,
} from '../../store/modules/videos/actions';
import { selectVideoList } from '../../store/modules/videos/selectors';
import { useActionDispatcher, useTitle } from '../../hooks';
import DeleteAction from '../../components/action/DeleteAction';
import AdvancedActionCell from '../../components/action-cell/AdvancedActionCell';

const title = 'Videos';

const VideoList = () => {
  useTitle(title);

  const { loading, data, dirty } = useSelector(selectVideoList);

  const getVideoList = useActionDispatcher(getVideoListRequest);
  const setDirty = useActionDispatcher(setVideoListDirty);
  const deleteVideo = useActionDispatcher(deleteVideoRequest);

  return (
    <ViewFrame title={title}>
      <ListTable
        columns={[

          {
            id: 'title',
            Header: 'Title',
          },
          {
            id: 'ref.created_age',
            Header: 'Created',
            width: 100,
          },
          {
            id: 'ref.user.full_name_first_last',
            Header: 'Owner',
            width: 130,
          },
          {
            id: 'ref.organization.common_name',
            Header: 'Organization',
            width: 130,
          },
          {
            id: 'actions',
            accessor: 'id',
            Cell: (cell: CellInfo) => (
              <AdvancedActionCell>
                {
                  cell.original.permissions.can_delete &&
                  <DeleteAction {...cell} onDelete={deleteVideo} />
                }
              </AdvancedActionCell>
            ),
            width: 65,
          },
        ]}
        loading={loading}
        data={data}
        fetch={getVideoList}
        dirty={Boolean(dirty)}
        setDirty={setDirty}
      />
    </ViewFrame>
  );
};

export default VideoList;
